import { createUseStyles } from "react-jss";

export const FooterStyle = createUseStyles((theme: any) => ({
    footer: {
        display: "flex",
        justifyContent: "center",
        padding: "var(--padding-sizes-sm)",
        gap: "var(--gaps-sizes-base)",
        background:"white",
        flexWrap:"wrap", 
    },
}));
